import {useField} from 'formik';
import {useCallback} from 'react';

import {Radio, RadioProps} from './Radio';

type Props = {
    name: string;
    value: any;
} & Partial<RadioProps>

export const RadioFormik: React.FC<Props> = ({name, ...props}: Props) => {
    const [, , helpers] = useField(name);

    const handleSelect = useCallback((value: string) => {
        helpers.setValue(value);
    }, [helpers]);

    return <Radio name={name} {...props} onSelect={handleSelect} />;
};
